import React from 'react';
import {connect} from 'react-redux';
import {pushState} from 'redux-router';
import { isMA, isRpmEnrollerClinicalCenter } from '../utils';

/** Default queue routes from center flags — safe to realign after profile switch. */
const PROFILE_LANDING_PATHS = new Set([
    '/home/unverified',
    '/home/rpmenrollment',
    '/home/rpmunverified',
    '/home/search',
    '/home/active',
    '/home/patientServices',
    '/home/mypatients',
    '/home/records'
]);

function getHomeLandingPath ( activeUser, userRoles ) {
    if ( !activeUser || !activeUser.center ) {
        return null;
    }
    const c = activeUser.center;
    if ( c.ce_flag ) {
        return '/home/unverified';
    }
    if ( isRpmEnrollerClinicalCenter( activeUser, userRoles ) ) {
        return '/home/search';
    }
    if ( c.rpm_flag ) {
        return '/home/rpmenrollment';
    }
    if ( c.gaps_flag ) {
        return '/home/active';
    }
    if ( c.support_flag ) {
        return '/home/patientServices';
    }
    if ( isMA( userRoles ) ) {
        return '/home/mypatients';
    }
    return '/home/records';
}

export function requireAuthentication ( Component ) {

    class AuthenticatedComponent extends React.Component {

        componentDidMount () {
            this.checkAuth();
        }

        componentDidUpdate ( prevProps ) {
            this.profileJustSwitched = prevProps.activeUser &&
                this.props.activeUser &&
                prevProps.activeUser.id !== this.props.activeUser.id;
            this.checkAuth();
        }

        checkAuth () {
            if ( !this.props.isAuthenticated ) {
                let redirectAfterLogin = this.props.location.pathname;
                const phoneQuery = this.props.location.query.phone;

                if ( redirectAfterLogin == '/' ) {
                    redirectAfterLogin = 'home';
                }
                if ( redirectAfterLogin ) {
                    if ( phoneQuery ) {
                        this.props
                            .dispatch( pushState( null, `/login?next=${redirectAfterLogin}&phone=${phoneQuery}` ) );
                    } else {
                        this.props
                            .dispatch( pushState( null, `/login?next=${redirectAfterLogin}${this.props.location.search}` ) );
                    }

                }
            } else {
                const { location, activeUser, user } = this.props;
                const path = location.pathname;
                const landingPath = getHomeLandingPath( activeUser, user.roles );

                if ( path === '/' ) {
                    this.props.dispatch( pushState( null, `/home` ) );
                    return;
                }

                if ( !landingPath || !activeUser || !activeUser.center ) {
                    return;
                }

                if ( isRpmEnrollerClinicalCenter( activeUser, user.roles ) ) {
                    const onPatientChart = path.indexOf( '/home/patient/' ) === 0;
                    const onLookup = path === '/home/search' || path.indexOf( '/home/search/' ) === 0;
                    const onAllPatientsQueue = path === '/home/allPatients';
                    const onAllApcmPatientsQueue = path === '/home/allAPCMPatients';
                    if ( path.indexOf( '/home/' ) === 0 && !onPatientChart && !onLookup
                        && !onAllPatientsQueue && !onAllApcmPatientsQueue ) {
                        this.props.dispatch( pushState( null, '/home/search' ) );
                        return;
                    }
                }

                const atHomeRoot = path === '/home';
                const onProfileLanding = PROFILE_LANDING_PATHS.has( path );

                const shouldApplyLanding = atHomeRoot ||
                    ( this.profileJustSwitched && onProfileLanding && landingPath !== path );

                if ( shouldApplyLanding ) {
                    this.props.dispatch( pushState( null, landingPath ) );
                }

                this.profileJustSwitched = false;
            }
        }

        render () {
            return (
                <div>
                    {this.props.isAuthenticated === true
                        ? <Component {...this.props}/>
                        : null
                    }
                </div>
            );

        }
    }

    const mapStateToProps = ( state ) => ({
        token: state.auth.token,
        userName: state.auth.userName,
        isAuthenticated: state.auth.isAuthenticated,
        activeUser: state.admin.activeUser,
        user: state.auth
    });

    return connect( mapStateToProps )( AuthenticatedComponent );

}
